"use client";

import { FrappeProvider } from "frappe-react-sdk";
import { EnvironmentBanner } from "@/components/environment-banner";
import { AuthProvider } from "@/lib/auth-context";
import { useMemo } from "react";
import { expandRuntimeConfig, RuntimeConfigProvider } from "@/lib/runtime-config";
import type { PublicRuntimeConfig } from "@/lib/runtime-config";

const EMPTY_CONFIG: PublicRuntimeConfig = {};

export function Providers({ children, config: publicConfig = EMPTY_CONFIG }: { children: React.ReactNode; config?: PublicRuntimeConfig }) {
  const config = useMemo(() => expandRuntimeConfig(publicConfig), [publicConfig]);
  // Browser talks to Frappe through the same-origin proxy
  // (app/api/method/[...method]) so session cookies stay first-party and
  // no public backend URL is configured in the browser at all. The
  // backend origin lives server-side only (BASE_URL / INTERNAL_URL).
  const frappeUrl = typeof window !== "undefined" ? window.location.origin : "";
  return (
    <RuntimeConfigProvider config={config}>
      <FrappeProvider url={frappeUrl} enableSocket={config.realtime.enabled} siteName={config.realtime.siteName || undefined}>
        <AuthProvider>
          <div className={config.uatMode ? "application-root application-root--uat" : "application-root"}>
            {children}
          </div>
        </AuthProvider>
      </FrappeProvider>
      <EnvironmentBanner />
    </RuntimeConfigProvider>
  );
}
